import {
    SUPPORTER_DETAILS_REQUEST_SUPPORTER,
    SUPPORTER_DETAILS_RECEIVE_SUPPORTER,
    SUPPORTER_DETAILS_CHANGE_VALUE,
    SUPPORTER_DETAILS_TOOGLE_BOOLEAN_VALUE,
    SUPPORTER_DETAILS_SEND_SAVE,
    SUPPORTER_DETAILS_RECEIVE_SAVE,
    SUPPORTER_DETAILS_RECEIVE_SAVE_ERROR,
    SUPPORTER_DETAILS_EDIT
} from "../config/actions";
import moment from 'moment';

let defaultState = {
    id: null,
    lastname: '',
    firstname: '',
    nickname: '',
    pronoun: null,
    pronounOthers: '',
    email: '',
    phone: '',
    birthday: '',
    zipcode: '',
    city: '',
    handycap: '',
    application: '',
    firstFusionYear: '',
    previousWorkType: null,
    setNewPassword: false,
    newPassword: '',
    edit: false,
    loading: false,
    errors: false,
    availableForBottleDeposit: false,
    stewardFormReceived: false,
};

const supporterDetailsReducer = (state = defaultState, action) => {
    switch (action.type) {
        case(SUPPORTER_DETAILS_REQUEST_SUPPORTER):
            return Object.assign({}, state, defaultState);
        case(SUPPORTER_DETAILS_RECEIVE_SUPPORTER):
            return Object.assign({}, state, {
                id: action.data.id,
                lastname: action.data.lastname,
                firstname: action.data.firstname,
                nickname: action.data.nickname !== null ? action.data.nickname : '',
                pronoun: action.data.pronoun,
                pronounOthers: action.data.pronounOthers !== null ? action.data.pronounOthers : '',
                email: action.data.email,
                phone: action.data.phone !== null ? action.data.phone : '',
                birthday: action.data.birthday !== null ? moment(action.data.birthday).format('DD.MM.YYYY') : '',
                zipcode: action.data.zipcode !== null ? action.data.zipcode : '',
                city: action.data.city !== null ? action.data.city : '',
                country: action.data.country !== null ? action.data.country : '',
                handycap: action.data.handycap !== null ? action.data.handycap : '',
                application: action.data.application !== null ? action.data.application : '',
                firstFusionYear: action.data.firstFusionYear !== null ? action.data.firstFusionYear : '',
                previousWorkType: action.data.previousWorkType,
                setNewPassword: false,
                newPassword: '',
                availableAsSteward: action.data.availableAsSteward,
                availableForBottleDeposit: action.data.availableForBottleDeposit,
                stewardFormReceived: action.data.stewardFormReceived,
            });
        case(SUPPORTER_DETAILS_CHANGE_VALUE):
            return Object.assign({}, state, {
                [action.name]: action.value
            });
        case(SUPPORTER_DETAILS_TOOGLE_BOOLEAN_VALUE):
            return Object.assign({}, state, {
                [action.name]: !state[action.name]
            });
        case(SUPPORTER_DETAILS_EDIT):
            return Object.assign({}, state, {
                edit: true
            });
        case(SUPPORTER_DETAILS_SEND_SAVE):
            return Object.assign({}, state, {
                errors: false,
                loading: true
            });
        case(SUPPORTER_DETAILS_RECEIVE_SAVE):
            return Object.assign({}, state, {
                edit: false,
                loading: false,
                setNewPassword: false,
                newPassword: ''
            });
        case(SUPPORTER_DETAILS_RECEIVE_SAVE_ERROR):
            return Object.assign({}, state, {
                edit: true,
                loading: false,
                errors: action.data.errors
            });
        default:
            return state;
    }
};

export default supporterDetailsReducer;